import constants from 'app/constants'
import fetchJSONData from 'app/util/fetchJSONData'
import parseSubUtility from './parse/parseSubUtility'

const cache = {}

/**
 * Get the utility
 *
 * @param {Array} id - the id to check for utility against
 * @param {Array} utilityConfig - the utility config
 * @returns {object} the result data
 */
export default async function getUtility (id, utilityConfig = {}) {
  const ids = [id] // hotifx patch for switching to GET
  // Check if all the requested IDs are present in the cache
  const allIdsInCache = ids.every(id => id in cache)

  // If all IDs are in the cache, return the subset of the cache
  if (allIdsInCache) {
    const resultFromCache = {}

    ids.forEach(id => {
      resultFromCache[id] = cache[id]
    })

    return {
      data: resultFromCache,
      success: true
    }
  }

  // If not all IDs are in the cache, fetch the data from the API
  const res = await fetchJSONData(
    `${constants.API_URL}/utility/get_utility_nft?network=constants.NETWORK&nft_id=${id}`,
    {
      method: 'GET',
      headers: {
        'company-id': constants.API_ID,
        'Content-Type': 'application/json'
      }
    },
    false
  )

  if (res.success) {
    Object.keys(res.data).forEach(key => {
      if (cache[key]) {
        res.data[key] = cache[key]

        return
      }

      res.data[key] = parseSubUtility(res.data[key] || [], utilityConfig)
    })

    // Update the cache with the newly fetched data
    Object.assign(cache, { ...res.data })
  }

  return res
}
